export function csChatBuilder(chatText?: string) {
  const number = process.env.REACT_APP_CS_NUMBER;
  const text =
    chatText || 'Halo Customer Service Lifepack, Saya ingin bertanya..';
  return number ? `https://wa.me/${number}?text=${text}` : '#';
}
